module.exports = __webpack_public_path__ + "img/live-arrow-down.svg";